/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCollection = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    // function to check if browser is IE
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    // Ensure product media libraries are present
    if (!isIE11) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ],)
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function() {
        window.PXUTheme.jsCollection.filterURL();
      });
    }

    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-tag-filter-checkbox]:checked').each(function(){
        window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      })
    }

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }

    /* Collection sidebar filter */
    $('body').on('click', '[data-option-filter]', function(e) {
      e.preventDefault();

      $(this).find('input').prop('checked', true);

      window.PXUTheme.jsCollection.multiTagFilter.init($(this));
      window.PXUTheme.scrollToTop($('.collection__content'));
    });

    $('body').on('click', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      window.PXUTheme.scrollToTop($('.collection__content'));

    });
  },
  filterURL: function() {

    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname');

    // check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
    if (window.PXUTheme.routes.root_url.length > 1) {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var url3 = $.url('3') ? $.url('3') + '/' : '';
      var path = url1 + url2 + url3;
    } else {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var path = url1 + url2;
    }

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    window.PXUTheme.queryParameters.sort_by = query;
    query = '?' + $.param(window.PXUTheme.queryParameters);

    this.processUrl(path, currentTags, query);
  },
  processUrl: function (path, tags, query) {

    var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';

    urlString = path + tags + query;

    this.updateView(urlString);

  },
  updateView: function(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      success: function(data) {
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    }).then(function(data){

      const $breadcrumbContainer = $('.breadcrumb__container');
      const $collectionMatrix = $('.collection-matrix');
      const $collectionMain = $('[data-collection-main]');

      // Get and set new breadcrumb html
      const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(filteredBreadcrumb);

      // Remove loading animation
      $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

      // Check for products
      const filteredData = $(data).find('.collection-matrix__wrapper');
      const filteredPageLinks = $(data).find('.container--pagination');
      const noProducts = $(data).find('.container--no-products-in-collection');

      if (filteredData.length) {
        // Add products to container
        $collectionMain.empty();
        $collectionMain.append(filteredData);
      } else {
        // Display no product message
        $collectionMain.empty();
        $collectionMain.append(noProducts);
      }

      $collectionMain.append(filteredPageLinks);

      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      // Initiate infinite scrolling on new products appended to collection grid
      if ($('[data-custom-pagination]').length) {
        window.PXUTheme.infiniteScroll.init();
      }

    });
  },
  multiTagFilter: {
    init: function ($el) {

      // Show filter and hide siblings
      this.showSelectedFilter($el);

      // Update url
      window.PXUTheme.jsCollection.filterURL();

      var urlIndex;
      if (window.PXUTheme.routes.root_url.length > 1) {
        urlIndex = 3
      } else {
        urlIndex = 2
      }

      // Hide filters if types or vendors is in URL (can't be combined)
      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }

    },
    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      // If sidebar toggle is enabled, show filter in sidebar content
      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

        window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
      }

    },
    clearSelectedFilter: function ($el) {

      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active')
            .find('input').prop("checked", false);
      $filterItem.siblings()
            .removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]')
            .addClass('is-hidden');

      //Update url
      window.PXUTheme.jsCollection.filterURL();
    }
  },
  unload: function($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    window.PXUTheme.breadcrumbs.unload();
  }
}

/******/ })()
;

// Restore native collections after returning from a product, including loaded pages.
(function () {
  if (!document.getElementById('template-collection') || window.zimmerliCollectionReturn) return;
  window.zimmerliCollectionReturn = true;

  const storageKey = 'zimmerli-native-collection-return';
  const cacheKey = storageKey + '-html';
  const gridSelector = '[data-collection-main] [data-load-more--grid]';
  const productSelector = gridSelector + ' [data-load-more--grid-item]';
  let stopRestoring = function () {};
  let selectedProduct;

  function cacheContext() {
    return document.documentElement.lang + ':' + (window.Shopify?.currency?.active || '');
  }

  function readSaved() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (saved && saved.collection === collectionURL() && saved.context === cacheContext() &&
          Date.now() - saved.time < 1800000 && Number.isFinite(saved.offset)) return saved;
    } catch (error) {
      // Storage is optional; normal collection navigation remains available.
    }
  }

  function saveCollection() {
    if (!selectedProduct || selectedProduct.collection !== collectionURL()) return;
    const grid = document.querySelector(gridSelector);
    const pagination = grid?.closest('[data-collection-main]').querySelector('.container--pagination');
    if (!grid || !pagination) return;
    try {
      // Keep one snapshot per tab, replacing any previous collection.
      sessionStorage.removeItem(cacheKey);
      sessionStorage.setItem(storageKey, JSON.stringify(selectedProduct));
      if (grid.classList.contains('loading-in-progress') || pagination.querySelector('[data-load-more].is-loading')) return;
      const clone = grid.cloneNode(true);
      // Images captured during lazy loading need to be eligible for loading again.
      clone.querySelectorAll('img.lazyloading').forEach(function (image) {
        image.classList.remove('lazyloading');
        image.classList.add('lazyload');
      });
      const snapshot = JSON.stringify({
        time: selectedProduct.time,
        grid: clone.innerHTML,
        pagination: pagination.innerHTML
      });
      // Leave room for the rest of the theme's session storage.
      if (snapshot.length <= 2000000) sessionStorage.setItem(cacheKey, snapshot);
    } catch (error) {
      // Quota/private-mode failures fall back to restoring through the native loader.
    }
  }

  function restoreCache() {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!navigation || navigation.type !== 'back_forward') return;
    // This deferred asset runs before DOMContentLoaded and the theme's loader init.
    // If loaded late, do not replace a grid that could already have requests in flight.
    if (window.PXUTheme.infiniteScroll.defaults) return;
    const saved = readSaved();
    const grid = document.querySelector(gridSelector);
    const pagination = grid?.closest('[data-collection-main]').querySelector('.container--pagination');
    if (!saved || !grid || !pagination) return;
    try {
      const snapshot = JSON.parse(sessionStorage.getItem(cacheKey));
      if (!snapshot || snapshot.time !== saved.time || typeof snapshot.grid !== 'string' || typeof snapshot.pagination !== 'string') return;
      grid.innerHTML = snapshot.grid;
      pagination.innerHTML = snapshot.pagination;
      // Infinite-load-more may already have been activated before leaving.
      const infiniteLink = pagination.querySelector('[data-load-infinite]');
      if (infiniteLink && !pagination.querySelector('[data-load-more-infinite]')) {
        infiniteLink.setAttribute('data-load-infinite-scroll', '');
      }
      const target = Array.from(grid.querySelectorAll('a[href]')).find(function (link) {
        return link.pathname === saved.product;
      })?.closest('[data-load-more--grid-item]');
      if (target) window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - saved.offset), behavior: 'instant' });
    } catch (error) {
      // Invalid/missing cache leaves the native loader available as a fallback.
    }
  }

  function collectionURL() {
    const url = new URL(window.location.href);
    url.searchParams.sort();
    return url.pathname + url.search;
  }

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    const product = link && link.closest('[data-load-more--grid-item]');
    if (!product || !product.closest(gridSelector) || link.target === '_blank' || link.origin !== window.location.origin || !link.pathname.includes('/products/')) return;

    selectedProduct = {
        collection: collectionURL(),
        product: link.pathname,
        offset: product.getBoundingClientRect().top,
        context: cacheContext(),
        time: Date.now()
    };
  }, true);

  function restore() {
    stopRestoring();
    const saved = readSaved();
    if (!saved) return;

    const previousRestoration = history.scrollRestoration;
    history.scrollRestoration = 'manual';
    const started = Date.now();
    let lastCount = -1;
    let settledAt = 0;
    let lastTop = null;
    let timer;
    const cancelEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];

    stopRestoring = function () {
      clearInterval(timer);
      history.scrollRestoration = previousRestoration;
      cancelEvents.forEach(function (name) {
        window.removeEventListener(name, stopRestoring);
      });
    };
    cancelEvents.forEach(function (name) {
      window.addEventListener(name, stopRestoring, { passive: true });
    });

    function tick() {
      if (collectionURL() !== saved.collection || Date.now() - started > 30000) {
        stopRestoring();
        return;
      }
      const grid = document.querySelector(gridSelector);
      if (!grid) return;
      const products = Array.from(document.querySelectorAll(productSelector));
      const target = products.find(function (product) {
        return Array.from(product.querySelectorAll('a[href]')).some(function (link) {
          return link.pathname === saved.product;
        });
      });

      if (target && target.getBoundingClientRect().height) {
        const top = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: Math.max(0, top - saved.offset), behavior: 'instant' });
        if (lastTop !== top) {
          lastTop = top;
          settledAt = Date.now();
        }
        // Allow lazy images and the grid image layout to settle before releasing scroll.
        if (Date.now() - settledAt > 1500) stopRestoring();
        return;
      }

      settledAt = 0;
      lastTop = null;
      if (!products.length || !grid.getBoundingClientRect().height) return;
      const main = grid.closest('[data-collection-main]');
      const loadMore = main.querySelector('[data-load-more]:not(.is-hidden)');
      const enableInfinite = main.querySelector('[data-load-more-infinite]');
      const infiniteLink = main.querySelector('[data-load-infinite]');
      if (!loadMore && !infiniteLink) {
        stopRestoring();
        return;
      }
      // Use the theme's existing AJAX and Waypoint loaders to preserve pagination.
      if (loadMore) {
        if (loadMore.classList.contains('is-loading') || products.length === lastCount) return;
        if (!window.PXUTheme.infiniteScroll.defaults) return;
        lastCount = products.length;
        loadMore.click();
      } else {
        if (!window.PXUTheme.infiniteScroll.defaults || !window.Waypoint || grid.classList.contains('loading-in-progress')) return;
        if (enableInfinite) enableInfinite.click();
        window.scrollTo({ top: grid.getBoundingClientRect().bottom + window.scrollY - window.innerHeight + 1, behavior: 'instant' });
        window.Waypoint.refreshAll();
      }
    }

    timer = setInterval(tick, 150);
    tick();
  }

  restoreCache();
  window.addEventListener('pagehide', function () {
    saveCollection();
    selectedProduct = null;
    stopRestoring();
  });
  window.addEventListener('pageshow', function (event) {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (event.persisted || (navigation && navigation.type === 'back_forward')) restore();
  });
  // The asset can also be loaded after pageshow by the theme editor/app loader.
  if (document.readyState === 'complete') {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation && navigation.type === 'back_forward') restore();
  }
})();
